import { Component, Input, OnInit } from '@angular/core';
import { PhcUrl } from '../../../models/interfaces/portfolio-health-check-data';
import { getPHCUrls } from '../../../utils/functions.utils';
// import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics/adobe-analytics.service';

@Component({
  selector: 'phc-gauge-card',
  templateUrl: './gauge-card.component.html',
  styleUrls: ['./gauge-card.component.scss'],
})
export class GaugeCardComponent implements OnInit {
  @Input() percent = 0;
  @Input() text = '';

  title: String = '';

  urls: PhcUrl = {};

  constructor(
    // private adobeAnalyticsService: AdobeAnalyticsService
  ) {
    this.urls = getPHCUrls();
  }
  
  ngOnInit(): void {
    this.title = (this.text === "Well diversified") ? "Great job! Your portfolio is well balanced" : "Your portfolio could be diversified more";
  }

  callToAction() {
    // this.adobeAnalyticsService.CreateCTATrigger('portfolio-health-check', 'visit-goal-planner', 'Text-Link');
  }
}